import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useDataContext } from "../Context/dataContext";
import { FaUser, FaLock } from "react-icons/fa";

function Login() {
  const navigate = useNavigate();
  const { setLogged, setInfoTkn, url } = useDataContext();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async (email, password) => {
    try {
      const response = await axios.get(`${url}/Auth/loginAdmin/${email}/${password}`);
      setInfoTkn(response.data.data.access_token);
      setLogged(true);
      navigate("/UserPortal");
    } catch (error) {
      console.log(error);
      axios.get(`${url}/Auth/logoutAdmin/${email}`);
      toast.error("Ocurrió un error. Verifica tus datos e intenta nuevamente.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetchData(user, password);
    } catch (error) {
      toast.error("Correo o contraseña incorrectos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h2>Iniciar Sesión</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="user">Usuario</label>
            <div className="input-container">
              <FaUser className="input-icon" />
              <input
                type="text"
                id="user"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                required
                placeholder="Ingresa tu usuario"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="input-container">
              <FaLock className="input-icon" />
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Ingresa tu contraseña"
              />
            </div>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "...": "Iniciar Sesión"}
          </button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}

export { Login };
